export default __webpack_public_path__ + "static/media/img1.5876ccd3.png";